import type { CheckboxProps, ListProps, RadioProps } from '@mui/material';
import type { ImageProps, StaticImageData } from 'next/image';
import type { ReactElement, ReactNode } from 'react';

export enum IconType {
  RADIO = 'radio',
  CHECKBOX = 'checkbox',
  IMAGE = 'image',
}

export interface StyleProps {
  displayAsRow?: boolean;
}

interface BooleanButtonPropsBasics {
  'aria-label'?: string;
  affix?: ReactElement | string;
  className?: ListProps['className'];
  dense?: boolean;
  disabled?: boolean;
  endAdornment?: React.ReactNode;
  onClick?: () => void;
  radio?: boolean;
  selected?: boolean;
  src?: StaticImageData;
  subtitle?: string;
  title: ReactNode | string;
  type: IconType;
  displayAsRow?: boolean;
  bottomMargin?: boolean;
}

export interface BooleanButtonRadioProps extends BooleanButtonPropsBasics {
  type: IconType.RADIO;
  iconProps?: RadioProps;
}

export interface BooleanButtonCheckboxProps extends BooleanButtonPropsBasics {
  type: IconType.CHECKBOX;
  iconProps?: CheckboxProps;
}

export interface BooleanButtonImageProps extends BooleanButtonPropsBasics {
  type: IconType.IMAGE;
  iconProps?: ImageProps;
}

export interface ButtonIconPropsBase {
  type: IconType;
  checked?: boolean;
  ariaLabel?: string;
}

export interface ButtonRadioIconProps extends RadioProps {
  type: IconType.RADIO;
  checked?: boolean;
}

export interface ButtonCheckboxIconProps extends CheckboxProps {
  type: IconType.CHECKBOX;
  checked?: boolean;
}

export interface ButtonImageIconProps extends ImageProps {
  type: IconType.IMAGE;
  checked?: boolean;
}

export type BooleanButtonProps = BooleanButtonRadioProps | BooleanButtonCheckboxProps | BooleanButtonImageProps;
